import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom'

import { LPSnackBar } from './components/Common/LPSnackBar';
import { configMessagesConfigurationRequest } from './store/config/actions';
import { ConfigState } from './store/config/types';
import { ApplicationState } from './store/index';
import { UserContext } from './components/data/context';

function hashCode(s) {
  let h=0;
  for(let i = 0; i < s.length; i++) 
    h = Math.imul(31, h) + s.charCodeAt(i) | 0;
  return h;
}

export const Messages = () => {
  const config = useSelector<ApplicationState, ConfigState>((state) => state.config);
  const location = useLocation();
  const dispatch = useDispatch();
  const user = useContext(UserContext);
  const [dismissedMessages, setDismissedMessages] = React.useState<Set<number>>(new Set());

  if (!config?.messageConfig?.messages && !config?.messageConfig?.loading) {
    dispatch(configMessagesConfigurationRequest());
  }

  const handleDismiss = (hash: number) => {
    setDismissedMessages((prev) => new Set(prev).add(hash));
    localStorage.setItem(hash.toString(), 'dismissed');
  };

  React.useEffect(() => {
    if (config.messageConfig?.messages) {
      const dismissedSet = new Set<number>();
      
      config.messageConfig.messages.forEach((message) => {
        if (message.isDismissable) {
          const id = user?.id || '';
          const hashText = `${message.messageText}${id}`;
          const hash = hashCode(hashText);
          const dismissed = localStorage.getItem(hash.toString());

          if (dismissed === 'dismissed') {
            dismissedSet.add(hash);
          }
        }
      });

      setDismissedMessages(dismissedSet);
    }
  },[location, config.messageConfig, user]);

  return (
    <>
      {config.messageConfig?.messages?.map((message) => {
        const id = user?.id || '';
        const hashText = `${message.messageText}${id}`;
        const hash = hashCode(hashText);
        const match = location.pathname === message.route;

        if (match && !dismissedMessages.has(hash)) {
          return (
            <LPSnackBar
              key={hash}
              isOpen={true}
              type="banner"
              message={message.messageText}
              disableAutoHide={true}
              isDismissable={message.isDismissable}
              onClose={() => handleDismiss(hash)}
            />
          );
        }

        return null;
      })}
    </>
  );
}